import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
 /* eslint-disable */
//import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import Urlbox from 'urlbox';
//import Lenis from 'lenis';

gsap.registerPlugin(ScrollToPlugin);

export default
{
    init()
    {

        window.disableHeaderAnim = false;

        $(document).on('click', '.menu-icon', function()
        {
            $(this).toggleClass('-is-active');
            window.toggleHeaderMenu();
        });

        function disableBodyScroll() {
            document.body.style.overflow = 'hidden';
        }

        function enableBodyScroll() {
            document.body.style.overflow = '';
        }

        $(document).on('click', '.search-icon', function() {
            $(this).toggleClass('-is-active');
            $('body > nav.site-navigation').toggleClass('-is-active');
            $('body > nav.site-navigation .site-menu-container').addClass('d-none');
            $('body > nav.site-navigation .search-form-container').toggleClass('d-none');
            $('.menu-icon').toggleClass('d-none');
            $('body > header.mobile-header').toggleClass('-is-active');

            $('.site-navigation').find('.social').closest('div').toggleClass('d-none');

            $('body > header.site-header:not(.-has-club-light-bg)').removeClass('hide-nav').addClass('show-nav');


            if ($(this).hasClass('-is-active')) {
                disableBodyScroll();
            } else {
                enableBodyScroll();
            }
        });

        function toggleHeaderMenu() {
            $('body > nav.site-navigation').toggleClass('-is-active');
            $('body > nav.site-navigation .site-menu-container').toggleClass('d-none');
            $('body > nav.site-navigation .search-form-container').addClass('d-none');
            $('.search-icon').toggleClass('d-none');
            $('body > header.mobile-header').toggleClass('-is-active');

            $('body > header.site-header:not(.-has-club-light-bg)').removeClass('hide-nav').addClass('show-nav');

            if ($('body > nav.site-navigation').hasClass('-is-active')) {
                disableBodyScroll();
            } else {
                enableBodyScroll();
            }
        }

        window.toggleHeaderMenu = toggleHeaderMenu;

        /*$(document).on('click', '.search-icon', function()
        {
            $(this).toggleClass('-is-active');
            $('body > nav.site-navigation').toggleClass('-is-active');
            $('body > nav.site-navigation .site-menu-container').addClass('d-none');
            $('body > nav.site-navigation .search-form-container').toggleClass('d-none');
            $('.menu-icon').toggleClass('d-none');
            $('body > header.mobile-header').toggleClass('-is-active');
        })

        function toggleHeaderMenu()
        {
            $('body > nav.site-navigation').toggleClass('-is-active');
            $('body > nav.site-navigation .site-menu-container').toggleClass('d-none');
            $('body > nav.site-navigation .search-form-container').addClass('d-none');
            $('.search-icon').toggleClass('d-none');
            $('body > header.mobile-header').toggleClass('-is-active');

            //$('body > header').toggleClass('-has-club-light-bg');
        }*/

        window.toggleHeaderMenu = toggleHeaderMenu;

        const sTheLoader = '<div class="loadingio-spinner-spinner-nq4q5u6dq7r"><div class="ldio-x2uulkbinc"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>';
        window.sTheLoader = sTheLoader;

        var iTheWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        var iTheHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

        window.iTheWidth = iTheWidth;
        window.iTheHeight = iTheHeight;

        var lastScrollTop;
        window.lastScrollTop = lastScrollTop;

        

        //const ajax_url = '/wp-content/themes/nth-5.3/resources/ajax.php';

        /* ------------------------------------------------------------------------------------------*/

        // AJAX UTILITIES

        /* ------------------------------------------------------------------------------------------*/


        var Ajax =
        {
            token: '',
            url: '/wp-content/themes/nth-5.3/resources/ajax.php',
            execute: function (payload, success, failure, timeout = 12000)
            {
                var contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
                var processData = true;
                var cache = true;
                var async = payload.async === false ? false : true;

                //console.log (timeout);  

                if (payload.data instanceof FormData) {
                    // set config values
                    processData = false;
                    cache = false;
                    contentType = false;

                    payload.data.append('class', payload.class);
                    payload.data.append('method', payload.method);
                    // Can only store string-data so JSON-ify params
                    payload.data.append('json', JSON.stringify(payload.param));

                    // set data proper
                    payload = payload.data;
                } else
                    payload.token = Ajax.token;


                ////////console.log (payload);

                $.ajax({
                    type: 'POST',
                    url: Ajax.url,
                    contentType: contentType,
                    processData: processData,
                    cache: cache,
                    data: payload,
                    async: async,
                    success: function (data) {
                        //console.log (data);
                        if (data.result === 'success')
                        {
                            if (success instanceof Function)
                                success(data);
                        } else {
                            if (failure instanceof Function)
                                failure(data);
                        }
                    },
                    error: function (jqXHR, status) {
                        //console.log('failure: ' + status);
                    },
                    timeout: timeout
                });
            },
        };

        window.Ajax = Ajax;


        // new 2023

        window.Ajax.prime_v2 = function ( sTheJson, success, failure )
        {
            ////console.log ( sTheJson );
            window.Ajax.execute ({ class: 'generate', method: 'prime_v2', param: sTheJson }, success, failure );
        }

        window.Ajax.frontpage_articles = function ( sTheJson, success, failure )
        {
            //console.log ( sTheJson );
            window.Ajax.execute ({ class: 'generate', method: 'frontpage_articles', param: sTheJson }, success, failure );
        }

        window.Ajax.mergeMatches = function ( sTheJson, success, failure )
        {
            window.Ajax.execute ({ class: 'generate', method: 'prime_merge_match_stats', param: sTheJson }, success, failure, 100000 );
        }


        window.Ajax.getNthData = function ( sTheJson, success, failure )
        {
            window.Ajax.execute ({ class: 'generate', method: 'get_nth_data', param: sTheJson }, success, failure );
        }

        window.Ajax.getPosts = function ( sTheJson, success, failure )
        {
            ////////console.log (sTheJson);
            window.Ajax.execute ({ class: 'generate', method: 'posts', param: sTheJson }, success, failure );
        }

        window.Ajax.importPosts = function ( sTheJson, success, failure )
        {
            ////////console.log (sTheJson);
            window.Ajax.execute ({ class: 'generate', method: 'import', param: sTheJson }, success, failure );
        }

        window.Ajax.convertPosts = function ( sTheJson, success, failure )
        {
            ////////console.log (sTheJson);
            window.Ajax.execute ({ class: 'generate', method: 'convert', param: sTheJson }, success, failure );
        }

        window.Ajax.getBroadcastData = function ( sTheJson, success, failure )
        {
            window.Ajax.execute ({ class: 'generate', method: 'getBroadcastData', param: sTheJson }, success, failure );
        }




        /* ------------------------------------------------------------------------------------------*/

        // GENERAL UTILITIES

        /* ------------------------------------------------------------------------------------------*/

        function isInViewport( $this, $container )
        {
            if( $this.length == 0 )
            {
                return;
            }
            var elementTop = $this.offset().top;
            var elementBottom = elementTop + $this.outerHeight();
            var viewportTop = $($container).scrollTop();

            var viewportBottom = viewportTop + window.iTheHeight;
            return elementBottom > viewportTop && elementTop < viewportBottom;
        }
        window.isInViewport = isInViewport;


        function isBelowViewport ( $this, $container )
        {
            if( $this.length == 0 )
            {
                return;
            }
            var elementTop = $this.offset().top;
            var viewportBottom = $($container).scrollTop() + window.iTheHeight;
            return elementTop > viewportBottom;
        }

        window.isBelowViewport = isBelowViewport;

        function isAboveViewport( $this, $container )
        {
            if( $this.length == 0 )
            {
                return;
            }
            var elementBottom = $this.offset().top + $this.outerHeight();
            var viewportTop = $($container).scrollTop();


            return elementBottom < viewportTop;
        }
        window.isAboveViewport = isAboveViewport;


        function isTopAboveViewportTop( $this, $container )
        {
            if( $this.length == 0 )
            {
                return;
            }
            var elementTop = $this.offset().top;
            var viewportTop = $($container).scrollTop();

            //////console.log (elementTop);
            //////console.log (viewportTop);

            return elementTop < viewportTop;
        }
        window.isTopAboveViewportTop = isTopAboveViewportTop;


        function isBottomAboveViewportTop( $this, $container )
        {
            if( $this.length == 0 )
            {
                return;
            }
            var elementBottom = $this.offset().top + $this.outerHeight();
            var viewportTop = $($container).scrollTop();

            //////console.log (elementBottom);
            //////console.log (viewportTop);

            return elementBottom < viewportTop;
        }
        window.isBottomAboveViewportTop = isBottomAboveViewportTop;

        window.scrollDirection = 'none';



        function sortPlayersByOrder(a,b)
        {
            const startA = parseInt($(a).attr('data-player-number'));
            const startB = parseInt($(b).attr('data-player-number'));
            return startA - startB;
        }
        window.sortPlayersByOrder = sortPlayersByOrder;

        function showError(data)
        {
            // something meaningful
            //////console.log(data);

        }
        window.showError = showError;


        if ( $('.wordpress-content-container').find('.adsanity-inner').length > 0 )
        {
            $('.wordpress-content-container').find('.adsanity-inner').each( function ()
            {
                let w = $(this).find('img').attr('width');
                let h = $(this).find('img').attr('height');

                let iThePerc = 100;


                if (w > h)
                {
                    //Divide x by 100. Multiply x by y.

                    iThePerc = (w * 100) / h;
                }
                else if (h > w)
                {
                    iThePerc =(h * 100) / w;

                }

                $(this).css({'padding-bottom' : iThePerc + '%'});
                $('<span class="ad-label d-block">ANNONSE</span>').insertBefore( $(this) );


            });
        }

        function doResize ()
        {
            var iTheCellW = 0;

            window.iTheWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            window.iTheHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);




            /*if ( $('.prime-hero').length == 1)
            {
                $('.prime-hero .hero-content').css({'height' :  (window.iTheHeight - $('header.site-header').outerHeight()) + 'px', 'margin-top' :  $('header.site-header').outerHeight() + 'px'});
            }

            if ( $('.default-hero').length == 1)
            {
                $('.default-hero .hero-content').css({'height' :  (window.iTheHeight - $('header.site-header').outerHeight()) + 'px', 'margin-top' :  $('header.site-header').outerHeight() + 'px' });
            }
            */
            if ($('.header-offset').length > 0)
            {
                $('.header-offset').css({'margin-top' : $('header.site-header').outerHeight() + 'px'});
            }

            $('nav.site-navigation').css({'padding-top' :  $('header.site-header').outerHeight() + 'px' });

            if ($('.-is-sticky').length > 0)
            {
                iTheCellW = $('.-is-sticky.-is-first').outerWidth();

                $('.-is-sticky.-is-first').attr('data-width', (iTheCellW * 1.1));
                $('.-is-sticky.-is-first').css({'width' : (iTheCellW * 1.1) + 'px'});

                //$('.-is-sticky.-is-first').next().css({'padding-left' : (iTheCellW * 0.75) + 'px'});
                //$('.-is-sticky.-is-second').css({'left' : iTheCellW + 'px'});
            }

        }
        window.doResize = doResize;


        addEventListener("resize", (event) => {

            window.doResize();
            ////console.log ('resize');

        });



        function getUrlParameter(sParam)
        {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
            return false;
        }

        window.getUrlParameter = getUrlParameter;


        function setUrlParameter(key,val)
        {
            //var url = new URL(window.location.href);
            //url.searchParams.set(key, val);
            ////window.location.href = url.href;
            //window.history.pushState('', '', url.href);
        }

        window.setUrlParameter = setUrlParameter;


        function removeUrlParameters()
        {
            //var clean_uri = location.protocol + '//' + location.host + location.pathname;
            //window.history.replaceState({}, document.title, clean_uri);
        }

        window.removeUrlParameters = removeUrlParameters;

    },
    finalize()
    {

        var currentMatchOpen;
        window.currentMatchOpen = currentMatchOpen;

        var currentTrigger;
        window.currentTrigger = currentTrigger;

        var currentMatchHeader;
        window.currentMatchHeader = currentMatchHeader;

        var oTheActiveButton;
        window.oTheActiveButton = oTheActiveButton;

        var bThePageing = false;
        window.bThePageing = bThePageing;

        var nth_hero_scrolled = false;

        if ($('.frontpage-article-loader').length > 0)
        {
            $('.frontpage-article-loader').empty().append(window.sTheLoader);

            window.Ajax.frontpage_articles(
            {
                template: '.frontpage-article-loader',
                tournament_ids: $('.frontpage-article-loader').attr('data-tournament-ids') ? $('.frontpage-article-loader').attr('data-tournament-ids').split(',') : [],
                team_ids: $('.frontpage-article-loader').attr('data-team-ids') ? $('.frontpage-article-loader').attr('data-team-ids').split(',') : [],
                initial: true
            },
            function (data) {

                $(data.param.template).empty().append(data.markup);

                if( $(data.param.template).find('.prime-data.v2').length > 0 )
                {
                    $(data.param.template).find('.prime-data.v2').each(function (i) {
                        let oTheContainer = $(this);
                        let delay = (i + 1) * 100;
                        setTimeout(() => {
                            triggerAjax(oTheContainer);
                        }, delay);
                    });
                }
                    
            },
            function (data) {
                window.showError(data);
            });

        }
        

        /*-----------------------------------------------------------------------------------------------------*/
        // open, close additional info, nth homepage
        /*-----------------------------------------------------------------------------------------------------*/


        $(document).on('click', '.prime-match-header[data-href]', function()
        {
            if ($(this).attr('data-target') == '_blank')
            {
                var newwin = window.open($(this).attr('data-href'), '_blank');
                newwin.focus();
            }
            else
            {
                window.location.href = $(this).attr('data-href');
            }

        });



         $(document).on('click', '.child-pages > div', function(e)
        {
            $(this).closest('.child-pages').toggleClass('-is-active');

        });

        /*-----------------------------------------------------------------------------------------------------*/
        // stats table, expand hidden trows
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('click', '.prime-stats-table button.stats-expander', function()
        {
            var iTheID = $(this).closest('tr').attr('data-tournament-id');
            if ($(this).hasClass('-is-open'))
            {
                $('tr.prime-stats-expandable[data-tournament-id=' + iTheID + ']').addClass('-is-hidden');
                $(this).removeClass('-is-open');
                $(this).find('span').html('Mer info');
            }
            else
            {
                $('tr.prime-stats-expandable[data-tournament-id=' + iTheID + ']').removeClass('-is-hidden');
                $(this).addClass('-is-open');
                $(this).find('span').html('Lukk');
             }
        });

        /*-----------------------------------------------------------------------------------------------------*/
        // stats table, sorting
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('click', '.prime-stats-table th, .prime-stats-table th span', function()
        {
            $(this).closest('table').find('tbody').find('td').removeClass('-is-sorted');
            $(this).closest('table').find('tbody').find('td:nth-child(' + ($(this).index() + 1) + ')').addClass('-is-sorted');
        });

        /*-----------------------------------------------------------------------------------------------------*/
        // filter select action, NTH table and stats selectors on front page
        /*-----------------------------------------------------------------------------------------------------*/

        var sTheInitialArchiveHref = $('.archive-link').attr('href');

        $(document).on('change', '.prime-secondary-nav select', function(e)
        {
            
            let sTheURI = '';

            

            //if ($(this).closest('footer').length > 0)
            //{
                if ($(this).closest('.prime-secondary-nav').hasClass('table-selector'))
                {
                    //console.log ('2');
                    let iTheID = $(this).find('option:selected').attr('data-id');
                    sTheURI = '/tabell/?tournament=' + iTheID;
                    window.location.href = sTheURI;
                }
                else if ($(this).find('option:selected').attr('data-href'))
                {
                    //console.log ('1');
                    sTheURI = $(this).find('option:selected').attr('data-href');
                    window.location.href = sTheURI;
                }
                else if ($(this).attr('id') == 'news_selector')
                {
                    
                    //console.log ('3');

                    e.preventDefault();


                    $('.frontpage-article-loader').empty().append(window.sTheLoader);

                    var sTheArchiveHref = sTheInitialArchiveHref + 
                        '&type=' + $(this).find('option:selected').attr('data-type') + 
                        '&tournament=' + $(this).find('option:selected').attr('data-tournament-id') + 
                        '&category=' + $(this).find('option:selected').attr('data-cat-id') + 
                        '&tag=' + $(this).find('option:selected').attr('data-tag-id');

                    $('.archive-link').attr('href', sTheArchiveHref);

                    //return false;
                    var initialSetting = false;

                    if ($(this).find('option:selected').attr('data-type') == 'all')
                    {
                        initialSetting = true;
                    }


                    window.Ajax.frontpage_articles(
                    {
                        template: '.frontpage-article-loader',
                        initial: initialSetting,
                        type: $(this).find('option:selected').attr('data-type'),
                        tournament: $(this).find('option:selected').attr('data-tournament-id'),
                        category: $(this).find('option:selected').attr('data-cat-id'),
                        tag: $(this).find('option:selected').attr('data-tag-id'),
                        tournament_ids: $('.frontpage-article-loader').attr('data-tournament-ids') ? $('.frontpage-article-loader').attr('data-tournament-ids').split(',') : [],
                        team_ids: $('.frontpage-article-loader').attr('data-team-ids') ? $('.frontpage-article-loader').attr('data-team-ids').split(',') : [],
                        
                    },
                    function (data) {

                        $(data.param.template).empty().append(data.markup);
                            
                    },
                    function (data) {
                        window.showError(data);
                    });
                
                }

            //}

            
        });


        

        if ($('body').hasClass('page-template-template-stats'))
        {
            if (window.getUrlParameter('prime_type') == 'team')
            {
                var iTheTournamentID = 1 * window.getUrlParameter('prime_tournament_id');

                window.Ajax.getNthData (
                {
                },
                function (data)
                {
                    $.each(data.nthdata[0].seasons, function (key, val)
                    {
                        var iTheSelected = val.season;
                        $.each(val.tournament, function (kk, vv)
                        {
                            if (iTheTournamentID == vv.tournament_id)
                            {
                                window.bTheInitial = true;
                                //////console.log ('season selected from param');
                                //////console.log (iTheSelected);
                                //alert('here?????');
                                $('.prime-seasons').val( iTheSelected ).change();


                            }
                       });
                    });
                },
                function ()
                {
                    return (0);
                });

            }
            else if (window.getUrlParameter('prime_type') == 'tournament')
            {
                var iTheTournamentID = 1 * window.getUrlParameter('prime_item_id');

                window.Ajax.getNthData (
                {
                },
                function (data)
                {
                    $.each(data.nthdata[0].seasons, function (key, val)
                    {
                        var iTheSelected = val.season;
                        $.each(val.tournament, function (kk, vv)
                        {
                            if (iTheTournamentID == vv.tournament_id)
                            {
                                window.bTheInitial = true;
                                //////console.log ('season selected from param');
                                //////console.log (iTheSelected);
                                //alert('here?????');
                                $('.prime-seasons').val( iTheSelected ).change();


                            }
                       });
                    });
                },
                function ()
                {
                    return (0);
                });

            }
        }

        $(document).on('change', 'input.match-stats-checkbox', function()
        {
            let iTheMatchID = $(this).attr('data-match-id');
            if ($(this).prop('checked'))
            {
                $('.prime-periodized-stats-table').find('tr[data-match-id=' + iTheMatchID + ']').removeClass('-is-hidden').addClass('-is-visible');
            }
            else
            {
                $('.prime-periodized-stats-table').find('tr[data-match-id=' + iTheMatchID + ']').addClass('-is-hidden').removeClass('-is-visible');
            }
            $('.prime-periodized-stats-table').find('tr.-is-visible').each( function (i)
            {
                if (i % 2 === 0)
                {
                    $(this).addClass('-is-even').removeClass('-is-odd');
                }
                else
                {
                    $(this).addClass('-is-odd').removeClass('-is-even');
                }
            });
        });


        $(document).on('click', '.prime-combine-selected', function()
        {
            var aTheData = [];
            window.aTheData = aTheData;

            $(this).prop('disabled', 'disabled');

            var combineBtn = $(this);

            $('.prime-data.merged-matches').addClass('-is-loading').append(window.sTheLoader);
            $(this).closest('.prime-data').find('label').each (function ( )
            {
                if ( $(this).find('.match-stats-checkbox').prop('checked'))
                {
                    let ii = $(this).find('.match-stats-checkbox').attr('data-match-id');
                    aTheData.push(ii);
                }
            });

            window.Ajax.mergeMatches (
            {
                template: 'stats/merged.php',
                container: '.prime-data.merged-matches',
                data: aTheData,
            },
            function (data)
            {
                $(data.param.container).empty().append(data.markup);
                initializeTableSorter('body');
                combineBtn.prop('disabled', false).removeProp('disabled');

            },
            function (data)
            {
                window.showError(data);
            });

        });

        var oTheContainer;

        window.bTheInitial = true;
        window.sTheStatsQueryType = '';
        window.sTheStatsQueryId = 0;
        window.iTheStatsQueryTournament = 0;
        window.iTheStatsQueryFrom = 0;
        window.iTheStatsQueryTo = 0;

        /*-----------------------------------------------------------------------------------------------------*/
        // v2 2023
        /*-----------------------------------------------------------------------------------------------------*/
        // initial load
        /*-----------------------------------------------------------------------------------------------------*/

        $('body').find('.prime-data.v2').each(function (i) 
        {
            let oTheContainer = $(this);
            let delay = (i + 1) * 100;
            
            if (oTheContainer.hasClass('prime-hero') || oTheContainer.hasClass('prime-single-player-header') || oTheContainer.hasClass('prime-single-player-stats') || oTheContainer.closest('select').length == 1)
            {
                if (oTheContainer.hasClass('prime-single-player-header'))
                {
                    oTheContainer.empty().addClass('-is-loading-resources').append(window.sTheLoader);
                }
                setTimeout(() => {
                    triggerAjax(oTheContainer);
                }, delay);
            }
            else
            {
                oTheContainer.empty().addClass('-is-loading-resources').append(window.sTheLoader);
                setTimeout(() => {

                    let timeout = setTimeout(() => {
                        oTheContainer.empty().append(`
                            <div class="timeout-message">
                                Oops! Det tok lenger tid enn vi ønsket å hente data. <button class="retry-button prime-icon">Forsøk igjen!</button>
                            </div>
                        `);
        
                        // Add retry functionality
                        oTheContainer.find('.retry-button').on('click', function () {
                            oTheContainer.find('.timeout-message').remove();
                            oTheContainer.append(window.sTheLoader);
                            // Retry the AJAX call
                            triggerAjax(oTheContainer, timeout);
                        });
                    }, 10000); // Timeout set to 10 seconds
        
                    triggerAjax(oTheContainer, timeout);
                
                }, delay);
            }
        });
        
        function triggerAjax(oTheContainer, timeout = null) 
        {
            window.Ajax.prime_v2(
            {
                template: oTheContainer.attr('data-content-template'),
                id: oTheContainer.attr('data-id'),
                queryString: oTheContainer.attr('data-content-query'),
                queryType: oTheContainer.attr('data-query-type'),
                homeTeam: oTheContainer.attr('data-home-team'),
                awayTeam: oTheContainer.attr('data-away-team'),
                match: oTheContainer.attr('data-match'),
                container: oTheContainer.attr('data-content-container'),
            },
            function (data) {
                    
                if (timeout) clearTimeout(timeout);

                if (data.param)
                {
                    if ( $(data.param.container).hasClass('prime-matches-horizontal') && data.count == 0)
                    {
                        //console.log ('----');
                        //console.log (data);
                        //console.log ($(data.param.container).hasClass('prime-matches-horizontal'));

                        $(data.param.container).find('.nav').find('.nav-item').last().find('button').addClass('active');
                    }

                    $(data.param.container).removeClass('-is-loading-resources').empty().append(data.markup);
                    postProcessPrimeData($(data.param.container));
                    $(data.param.container).closest('.col').find('.prime-matches-single-info-title').removeClass('d-none');
                    if (data.count === 0 && $(data.param.container).hasClass('-if-empty-remove')) {
                        if ( $(data.param.container).closest('.tab-pane'))
                        {
                            $(data.param.container).closest('.tab-pane').closest('.tab-content').find('.tab-pane:not(.active)').addClass('active').addClass('show');  
                            $(data.param.container).closest('.tab-pane').removeClass('active').removeClass('show');
                            $(data.param.container).closest('.prime-match-slider-outer').find('.nav-link').each( function () 
                            {
                                if ($(this).hasClass('active'))
                                {
                                    $(this).removeClass('active');
                                    $(this).closest('.nav-item').remove();
                                }
                                else
                                {
                                    $(this).addClass('active');
                                    $(this).css({

                                        'pointer-events': 'none',
                                    });
                                }
                            });
                            
                        }
                        $(data.param.container).remove();

                    }
                
                }   
            },
            function (data) {
                if (timeout) clearTimeout(timeout);
                window.showError(data);
            });
        }

       
        /*-----------------------------------------------------------------------------------------------------*/
        // filter select
        /*-----------------------------------------------------------------------------------------------------*/
        // matches, seasons
        /*-----------------------------------------------------------------------------------------------------*/

        function calculateSelectWidth($select) {
            const temp = $('<span>').css({
                visibility: 'hidden',
                position: 'absolute',
                whiteSpace: 'nowrap',
                font: $select.css('font') // Match font for accurate width
            }).text($select.find(':selected').text());
        
            $('body').append(temp); // Add temporary span to body
            const width = temp[0].offsetWidth + 60; // Calculate width and add padding
            temp.remove(); // Remove temporary span
        
            return width; // Return calculated width
        }

        $('body:not(.page-template-template-stats)').find('.prime-filter-item').each(function () {


            const newWidth = calculateSelectWidth($(this));

            // Perform other actions, if any
            //$(this).css({'width' : newWidth + 'px'});

        });

        
        $(document).on('change', '.prime-schedule .prime-filter-item select.prime-seasons', function()
        {


            let oTheSelected = $(this).find('option:selected');
            oTheContainer = oTheSelected.attr('data-selector-container');
            $(oTheContainer).empty().append('<option>&nbsp;...&nbsp;</option>');



            if ($('.prime-tournaments').length > 0)
            {
                $('.prime-tournaments').empty().append('<option value="0">' + $('.prime-tournaments').attr('data-label')+ '</option>').prop('selected', 'selected').prop('disabled', 'disabled');
            }

            if ($('.prime-teams').length > 0 )
            {
                $('.prime-teams').empty().append('<option value="0">' + $('.prime-teams').attr('data-label')+ '</option>').prop('selected', 'selected').prop('disabled', 'disabled');
            }

            window.Ajax.prime_v2 (
            {
                template: oTheSelected.attr('data-selector-template'),
                id: oTheSelected.val(),
                queryString: oTheSelected.attr('data-selector-query'),
                queryType: oTheSelected.attr('data-query-type'),
                homeTeam: oTheSelected.attr('data-home-team'),
                awayTeam: oTheSelected.attr('data-away-team'),
                match: oTheSelected.attr('data-match'),
                container: oTheSelected.attr('data-selector-container'),
            },
            function (data)
            {
                $(oTheContainer).empty().append(data.markup).prop('disabled', false).removeProp('disabled');
                $('.prime-schedule .load-more').attr('data-page', 2);
                oTheContainer = oTheSelected.attr('data-content-container');
                $(oTheContainer).empty().append(window.sTheLoader);

                $(oTheContainer).attr('data-content-template', oTheSelected.attr('data-content-template'));
                $(oTheContainer).attr('data-id',  oTheSelected.val());
                $(oTheContainer).attr('data-content-query', oTheSelected.attr('data-content-query'));
                $(oTheContainer).attr('data-query-type', oTheSelected.attr('data-query-type'));
                $(oTheContainer).attr('data-content-container', oTheSelected.attr('data-content-container'));

                //console.log ('----');
                //console.log (oTheContainer);

                window.Ajax.prime_v2 (
                {
                    template: oTheSelected.attr('data-content-template'),
                    id: oTheSelected.val(),
                    queryString: oTheSelected.attr('data-content-query'),
                    queryType: oTheSelected.attr('data-query-type'),
                    homeTeam: oTheSelected.attr('data-home-team'),
                    awayTeam: oTheSelected.attr('data-away-team'),
                    match: oTheSelected.attr('data-match'),
                    container: oTheSelected.attr('data-content-container'),

                    



                },
                function (data)
                {
                    $(data.param.container).empty().append(data.markup);
                    postProcessPrimeData($(data.param.container));
                },
                function (data)
                {
                    window.showError(data);
                });
            },
            function (data)
            {
                window.showError(data);
            });
        });

        /*-----------------------------------------------------------------------------------------------------*/
        // matches, tournaments
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('change', '.prime-schedule .prime-filter-item select.prime-tournaments', function()
        {
            let oTheSelected = $(this).find('option:selected');
            oTheContainer = oTheSelected.attr('data-selector-container');
            $(oTheContainer).empty().append('<option>&nbsp;...&nbsp;</option>');

            if ($('.prime-teams').length > 0 )
            {
                $('.prime-teams').empty().append('<option value="0">' + $('.prime-teams').attr('data-label')+ '</option>').prop('selected', 'selected').prop('disabled', 'disabled');
            }

            if (!$('body').hasClass('page-template-template-stats'))
            {
                const newWidth = calculateSelectWidth($(this));
                $(this).css({'width' : newWidth + 'px'});
            }

            window.Ajax.prime_v2 (
            {
                template: oTheSelected.attr('data-selector-template'),
                id: oTheSelected.val(),
                queryString: oTheSelected.attr('data-selector-query'),
                queryType: oTheSelected.attr('data-query-type'),
                homeTeam: oTheSelected.attr('data-home-team'),
                awayTeam: oTheSelected.attr('data-away-team'),
                match: oTheSelected.attr('data-match'),
                container: oTheSelected.attr('data-selector-container'),
            },
            function (data)
            {
                $(oTheContainer).empty().append(data.markup).prop('disabled', false).removeProp('disabled');
                $('.prime-schedule .load-more').attr('data-page', 2);
                oTheContainer = oTheSelected.attr('data-content-container');
                $(oTheContainer).empty().append(window.sTheLoader);

                $(oTheContainer).attr('data-content-template', oTheSelected.attr('data-content-template'));
                $(oTheContainer).attr('data-id',  oTheSelected.val());
                $(oTheContainer).attr('data-content-query', oTheSelected.attr('data-content-query'));
                $(oTheContainer).attr('data-query-type', oTheSelected.attr('data-query-type'));
                $(oTheContainer).attr('data-content-container', oTheSelected.attr('data-content-container'));

                //console.log ('----');
                //console.log ($(oTheContainer));

                window.Ajax.prime_v2 (
                {
                    template: oTheSelected.attr('data-content-template'),
                    id: oTheSelected.val(),
                    queryString: oTheSelected.attr('data-content-query'),
                    queryType: oTheSelected.attr('data-query-type'),
                    homeTeam: oTheSelected.attr('data-home-team'),
                    awayTeam: oTheSelected.attr('data-away-team'),
                    match: oTheSelected.attr('data-match'),
                    container: oTheSelected.attr('data-content-container'),
                },
                function (data)
                {

                    //console.log ('----');
                    //console.log (data);
                    $(data.param.container).empty().append(data.markup);
                    postProcessPrimeData($(data.param.container));
                },
                function (data)
                {

                    //console.log ('----error');
                    //console.log (data);
                    window.showError(data);
                });
            },
            function (data)
            {
                window.showError(data);
            });
        });

        /*-----------------------------------------------------------------------------------------------------*/
        // matches, teams
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('change', '.prime-schedule .prime-filter-item select.prime-teams', function()
        {
            let oTheSelected = $(this).find('option:selected');
            let oTheContainer = oTheSelected.attr('data-content-container');
            $(oTheContainer).empty().append(window.sTheLoader);

            if (!$('body').hasClass('page-template-template-stats'))
            {
                const newWidth = calculateSelectWidth($(this));
                $(this).css({'width' : newWidth + 'px'});
            }

            $(oTheContainer).attr('data-content-template', oTheSelected.attr('data-content-template'));
            $(oTheContainer).attr('data-id',  oTheSelected.val());
            $(oTheContainer).attr('data-content-query', oTheSelected.attr('data-content-query'));
            $(oTheContainer).attr('data-query-type', oTheSelected.attr('data-query-type'));
            $(oTheContainer).attr('data-content-container', oTheSelected.attr('data-content-container'));

            window.Ajax.prime_v2 (
            {
                template: oTheSelected.attr('data-content-template'),
                id: oTheSelected.val(),
                queryString: oTheSelected.attr('data-content-query'),
                queryType: oTheSelected.attr('data-query-type'),
                container: oTheSelected.attr('data-content-container'),
            },
            function (data)
            {
                $(oTheContainer).empty().append(data.markup);
                $('.prime-schedule .load-more').attr('data-page', 2);
            },
            function (data)
            {
                window.showError(data);
            });
        });

        /*-----------------------------------------------------------------------------------------------------*/
        // load more button, click and update pageing parameter
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('click', '.prime-schedule .load-more', function()
        {
            let me = $(this);
            let iThePage = $(this).attr('data-page') * 1;
            me.prop('disabled', 'disabled');
            let oTheContainer = $(this).closest('.row').find('.content-container.prime-data');

            window.Ajax.prime_v2 (
            {
                template: oTheContainer.attr('data-content-template'),
                id: oTheContainer.attr('data-id'),
                queryString: oTheContainer.attr('data-content-query') + '&page=' + iThePage,
                queryType: oTheContainer.attr('data-query-type'),
                container: oTheContainer.attr('data-content-container'),
            },
            function (data)
            {
                $(oTheContainer).append(data.markup);
                me.attr('data-page', iThePage + 1);
                me.prop('disabled', false).removeProp('disabled');
            },
            function (data)
            {
                window.showError(data);
            });
        });


        /*-----------------------------------------------------------------------------------------------------*/
        // stats, seasons
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('change', '.prime-stats-section .prime-filter-item select.prime-seasons', function()
        {

            

            let oTheSelected = $(this).find('option:selected');
            oTheContainer = oTheSelected.attr('data-selector-container');
            $(oTheContainer).empty().append('<option>&nbsp;...&nbsp;</option>');

            if ($('.prime-tournaments').length > 0 )
            {
                $('.prime-tournaments').empty().append('<option value="0">Velg turnering</option>').prop('selected', 'selected').prop('disabled', 'disabled');
            }

            if ($('.prime-teams').length > 0 )
            {
                $('.prime-teams').empty().append('<option value="0">Velg lag</option>').prop('selected', 'selected').prop('disabled', 'disabled');
            }

            $('.prime-stats-section').attr('data-season', oTheSelected.val());

            window.sTheStatsQueryType = 'season';
            window.sTheStatsQueryId = oTheSelected.val();


            $('.content-container').find('.datepicker').prop('disabled', 'disabled');
            $('.content-container').find('.-has-datepicker').addClass('d-none');

            //console.log ('----');
            //console.log (oTheContainer);
            //console.log (oTheSelected.attr('data-selector-template'));
            //console.log (oTheSelected.val());
            //console.log ('---------'); 

            window.Ajax.prime_v2 (
            {
                template: oTheSelected.attr('data-selector-template'),
                id: oTheSelected.val(),
                queryString: oTheSelected.attr('data-selector-query'),
                queryType: oTheSelected.attr('data-query-type'),
                homeTeam: oTheSelected.attr('data-home-team'),
                awayTeam: oTheSelected.attr('data-away-team'),
                match: oTheSelected.attr('data-match'),
                container: oTheSelected.attr('data-selector-container'),
            },
            function (data)
            {
                /*es-lint-disable*/
                //console.log (data.markup);
                //console.log (data.param);
                /*es-lint-enable*/

                $(oTheContainer).empty().append(data.markup).prop('disabled', false).removeProp('disabled');
                postProcessPrimeData($(data.param.container));

                $('.prime-stats-container').html ('<div>Vennligst velg turnering!</div>');
            },
            function (data)
            {
                window.showError(data);
            });
        });


        /*-----------------------------------------------------------------------------------------------------*/
        // stats, tournaments
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('change', '.prime-stats-section .prime-filter-item select.prime-tournaments', function()
        {
            let oTheSelected = $(this).find('option:selected');
            oTheContainer = oTheSelected.attr('data-selector-container');
            $(oTheContainer).empty().append('<option>&nbsp;...&nbsp;</option>');

            if ($('.prime-teams').length > 0 )
            {
                $('.prime-teams').empty().append('<option value="0">' + $('.prime-teams').attr('data-label')+ '</option>').prop('disabled', 'disabled');
            }

            if ( $('.prime-stats-section').attr('data-context') != 'team')
            {

                $('.prime-stats-section').attr('data-tournament-id', oTheSelected.val());
            }

            window.sTheStatsQueryType = 'tournament';
            window.sTheStatsQueryId = oTheSelected.val();

            //alert (window.sTheStatsQueryId == $('.prime-stats-section').attr('data-tournament-id'));

            $('.content-container').find('.datepicker').prop('disabled', false).removeProp('disabled');
            $('.content-container').find('.-has-datepicker').removeClass('d-none');


            if (!window.getUrlParameter('prime_context'))
            {
                window.removeUrlParameters();
                window.setUrlParameter('prime_type', 'tournament');
                if (window.sTheStatsQueryId)
                {
                    window.setUrlParameter('prime_item_id', window.sTheStatsQueryId);
                }
            }
            else
            {
                window.setUrlParameter('prime_item_id', window.sTheStatsQueryId);
                if (window.bTheInitial == true && window.getUrlParameter('prime_context') == 'tournament')
                {
                    $('.prime-stats-filter').click();

                    let url = window.location.href;
                    url = url.replace('&prime_context=tournament', '');
                    window.history.replaceState({}, document.title, url);
                    window.bTheInitial = false;
                }
            }

            window.Ajax.prime_v2 (
            {
                template: oTheSelected.attr('data-selector-template'),
                id: oTheSelected.val(),
                queryString: oTheSelected.attr('data-selector-query'),
                queryType: oTheSelected.attr('data-query-type'),
                homeTeam: oTheSelected.attr('data-home-team'),
                awayTeam: oTheSelected.attr('data-away-team'),
                match: oTheSelected.attr('data-match'),
                container: oTheSelected.attr('data-selector-container'),
            },
            function (data)
            {
                $(oTheContainer).empty().append(data.markup).prop('disabled', false).removeProp('disabled');

                ////////console.log (data);

                if (data.param)
                {
                    postProcessPrimeData($(data.param.container));
                }

                $('.prime-stats-section .prime-stats-filter').click();

            },
            function (data)
            {
                window.showError(data);
            });



        });

        /*-----------------------------------------------------------------------------------------------------*/
        // stats, teams
        /*-----------------------------------------------------------------------------------------------------*/



        $(document).on('change', '.prime-stats-section .prime-filter-item select.prime-teams', function()
        {
            let oTheSelected = $(this).find('option:selected');

            if (oTheSelected.val() > 0)
            {
                window.sTheStatsQueryType = 'team';
                window.sTheStatsQueryId = oTheSelected.val();
                window.iTheStatsQueryTournament = $('.prime-tournaments').find('option:selected').val();

                if (!window.getUrlParameter('prime_context'))
                {
                    window.removeUrlParameters();
                    window.setUrlParameter('prime_type', 'team');
                    if (window.sTheStatsQueryId)
                    {
                        window.setUrlParameter('prime_item_id', window.sTheStatsQueryId);
                    }
                    window.setUrlParameter('prime_tournament_id', $('select.prime-tournaments').find('option:selected').val());
                }

                if (window.bTheInitial == true)
                {
                    $('.prime-stats-section').attr('data-team-id', oTheSelected.val());
                }

                $('.content-container').find('.datepicker').prop('disabled', 'disabled');
                $('.content-container').find('.-has-datepicker').addClass('d-none');

                $('.prime-stats-section .prime-stats-filter').click();

            }
            else
            {
                window.sTheStatsQueryType = 'tournament';
                window.sTheStatsQueryId = $('select.prime-tournaments').find('option:selected').val();

                if (window.bTheInitial == true)
                {
                    $('.prime-stats-section').attr('data-team-id', 0);
                }

                $('.content-container').find('.datepicker').prop('disabled', false).removeProp('disabled');
                $('.content-container').find('.-has-datepicker').removeClass('d-none');




            }
        });

        /*-----------------------------------------------------------------------------------------------------*/
        // stats, search button
        /*-----------------------------------------------------------------------------------------------------*/

        $('.prime-stats-section .prime-stats-filter').click( function ()
        {
            let me = $(this);

            //alert ('click');

            let oTheContainer = $('.prime-stats-container');

            let sTheQueryString = 'tournaments/'
                + $('.prime-stats-section').attr('data-tournament-id')
                + '/incidents/?usenif'
                + '&size=1000';


            let sThePageURL =  location.protocol + '//' + location.host + location.pathname;

            sThePageURL = sThePageURL + '?prime_type=' + window.sTheStatsQueryType;
            sThePageURL = sThePageURL + '&prime_item_id='+ window.sTheStatsQueryId;

            if (window.iTheStatsQueryTournament)
            {
                sThePageURL = sThePageURL + '&prime_tournament_id='+ window.iTheStatsQueryTournament;
            }

            let sThePageString = '<a href="' + sThePageURL + '" class="prime-icon prime-share-icon d-flex justify-content-end align-items-center -has-font-weight-300"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><path style="" d="M18,15.5c-1.1,0-2.1,0.5-2.7,1.3l-6-3.5c0.2-0.4,0.3-0.8,0.3-1.3c0-0.5-0.1-0.9-0.3-1.3l6-3.5C15.9,8,16.9,8.5,18,8.5 c1.9,0,3.5-1.6,3.5-3.5S19.9,1.5,18,1.5S14.5,3.1,14.5,5c0,0.5,0.1,0.9,0.3,1.3l-6,3.5C8.1,9,7.1,8.5,6,8.5c-1.9,0-3.5,1.6-3.5,3.5 s1.6,3.5,3.5,3.5c1.1,0,2.1-0.5,2.7-1.3l6,3.5c-0.2,0.4-0.3,0.8-0.3,1.3c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S19.9,15.5,18,15.5z M18,2.5c1.4,0,2.5,1.1,2.5,2.5S19.4,7.5,18,7.5S15.5,6.4,15.5,5S16.6,2.5,18,2.5z M6,14.5c-1.4,0-2.5-1.1-2.5-2.5 c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5C8.5,13.4,7.4,14.5,6,14.5z M18,21.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5 s2.5,1.1,2.5,2.5S19.4,21.5,18,21.5z"/></svg>Del</a>';

            $('.page-link-container').html(sThePageString).closest('.share-container').removeClass('d-none');
            /*
            window.iTheStatsQueryTournament = 0;
            window.iTheStatsQueryFrom = 0;
            window.iTheStatsQueryTo = 0;
            */


            if ( $('#datepicker_to').val() && $('#datepicker_from').val() )
            {
                //alert ('jadda');

                me.prop('disabled', 'disabled');

                $(oTheContainer).empty().addClass('-is-loading').append(window.sTheLoader);

                //query

                sTheQueryString = sTheQueryString + '&from=' + window.oTheParams['date_from'] + '&to=' + window.oTheParams['date_to'];

                window.Ajax.prime_v2 (
                {
                    template: 'stats/table.php',
                    id: window.sTheStatsQueryId,
                    queryString: sTheQueryString,
                    queryType: 'stats_' + window.sTheStatsQueryType + '_periodized',
                    container: '.prime-stats-container',
                },
                function (data)
                {
                    $(oTheContainer).html(data.markup).removeClass('-is-loading');
                    me.prop('disabled', false).removeProp('disabled');
                    postProcessPrimeData($(data.param.container));
                },
                function (data)
                {
                    window.showError(data);
                });



            }
            else if ($('#datepicker_to').val() && !$('#datepicker_from').val())
            {
                alert ('Du må velge en fra dato.' + window.oTheParams['date_to'] );

            }
            else if (!$('#datepicker_to').val() && $('#datepicker_from').val())
            {
                alert ('Du må velge en til dato.' + window.oTheParams['date_from'] );
            }
            else
            {

                me.prop('disabled', 'disabled');

                $(oTheContainer).empty().addClass('-is-loading').append(window.sTheLoader);

                sTheQueryString = sTheQueryString + '&summarized=true';

                window.Ajax.prime_v2 (
                {
                    template: 'stats/table.php',
                    id: window.sTheStatsQueryId,
                    queryString: sTheQueryString,
                    queryType: 'stats_' + window.sTheStatsQueryType,
                    container: '.prime-stats-container',
                },
                function (data)
                {
                    $(oTheContainer).html(data.markup).removeClass('-is-loading');
                    me.prop('disabled', false).removeProp('disabled');
                    postProcessPrimeData($(data.param.container));
                },
                function (data)
                {
                    window.showError(data);
                });
            }
        });



        /*-----------------------------------------------------------------------------------------------------*/
        // stats, single match - init tablesorter on tab open
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('shown.bs.tab', '.nav-tabs button', function()
        {

            var tabId = $(this).attr('data-bs-target');

            if ( $(tabId).find('.prime-data-defer').length > 0 )
            {
                let sTheContainer = $(tabId).find('.prime-data-defer').attr('data-content-container');
                let oTheContainer = $(sTheContainer);
                oTheContainer.empty().append(window.sTheLoader);

                window.Ajax.prime_v2 (
                {
                    template: oTheContainer.attr('data-content-template'),
                    id: oTheContainer.attr('data-id'),
                    queryString: oTheContainer.attr('data-content-query'),
                    queryType: oTheContainer.attr('data-query-type'),
                    homeTeam: oTheContainer.attr('data-home-team'),
                    awayTeam: oTheContainer.attr('data-away-team'),
                    match: oTheContainer.attr('data-match'),
                    container: oTheContainer.attr('data-content-container'),
                },
                function (data)
                {
                    if (data.count > 0)
                    {
                        $(data.param.container).empty().append(data.markup);
                        oTheContainer.removeClass('prime-data-defer').addClass('prime-data');
                        $(oTheContainer).find('.prime-match-pitch-stats-table').tablesorter({ sortList: [[3,1]], sortInitialOrder: 'desc' });
                        $(oTheContainer).find('.prime-match-pitch-stats-table').find('tbody').find('td:nth-child(4)').addClass('-is-sorted');
                        $(oTheContainer).find('.prime-match-goalie-stats-table').tablesorter({ sortList: [[2,1]], sortInitialOrder: 'desc' });
                        $(oTheContainer).find('.prime-match-goalie-stats-table').find('tbody').find('td:nth-child(3)').addClass('-is-sorted');
                    }
                },
                function (data)
                {
                    window.showError(data);
                });
            }
        });

        /*-----------------------------------------------------------------------------------------------------*/
        // ADMIN MATCH SELECTOR
        /*-----------------------------------------------------------------------------------------------------*/

        if ($('body').hasClass('page-template-template-matches-image') && $('body').hasClass('team'))
        {
            if (window.getUrlParameter('nth_season'))
            {
                var iTheSeason = window.getUrlParameter('nth_season') * 1;
                match_schedule_promo_get_tournaments( $('.prime-seasons') );
            }
        }
        else if ($('body').hasClass('page-template-template-matches-image') && $('body').hasClass('nth'))
        {
            $('.prime-seasons').val('2526').trigger('change');
            match_schedule_promo_get_tournaments( $('.prime-seasons') );
        }

        $(document).on('change', '.prime-matches-section .prime-filter-item select.prime-seasons', function()
        {
            match_schedule_promo_get_tournaments( $(this) );
        });

        function match_schedule_promo_get_tournaments($select) {

            let oTheSelected = $select.find('option:selected');

            //console.log ('season select action');
            //console.log(oTheSelected);

            oTheContainer = oTheSelected.attr('data-selector-container');
            $(oTheContainer).empty().append('<option>&nbsp;...&nbsp;</option>');

            if ($('.prime-tournaments').length > 0 )
            {
                $('.prime-tournaments').empty().append('<option value="0">Velg turnering</option>').prop('selected', 'selected').prop('disabled', 'disabled');
            }

            if ($('.prime-teams').length > 0 )
            {
                $('.prime-teams').empty().append('<option value="0">Velg lag</option>').prop('selected', 'selected').prop('disabled', 'disabled');
            }

            $('.prime-matches-section').attr('data-season', oTheSelected.val());
            $('.prime-matches-section').attr('data-tournament-id', '');
            $('.prime-matches-section').attr('data-team-id', '');

            window.Ajax.prime_v2 (
            {
                template: oTheSelected.attr('data-selector-template'),
                id: oTheSelected.val(),
                queryString: oTheSelected.attr('data-selector-query'),
                queryType: oTheSelected.attr('data-query-type'),
                container: oTheSelected.attr('data-selector-container'),
            },
            function (data)
            {
                $(oTheContainer).empty().append(data.markup).prop('disabled', false).removeProp('disabled');

                if (window.getUrlParameter('tournament_id'))
                {
                    $(oTheSelected.attr('data-selector-container')).val(window.getUrlParameter('tournament_id')).trigger('change');
                }
            },
            function (data)
            {
                window.showError(data);
            });
        };


        $(document).on('change', '.prime-matches-section .prime-filter-item select.prime-tournaments', function()
        {
            let oTheSelected = $(this).find('option:selected');
            oTheContainer = oTheSelected.attr('data-selector-container');
            $(oTheContainer).empty().append('<option>&nbsp;...&nbsp;</option>');

            if ($('.prime-teams').length > 0 )
            {
                $('.prime-teams').empty().append('<option value="0">' + $('.prime-teams').attr('data-label')+ '</option>').prop('disabled', 'disabled');
            }

            $('.prime-matches-section').attr('data-tournament-id', oTheSelected.val());
            $('.prime-matches-section').attr('data-team-id', '');


            window.Ajax.prime_v2 (
            {
                template: oTheSelected.attr('data-selector-template'),
                id: oTheSelected.val(),
                queryString: oTheSelected.attr('data-selector-query'),
                queryType: oTheSelected.attr('data-query-type'),
                container: oTheSelected.attr('data-selector-container'),
            },
            function (data)
            {
                $(oTheContainer).empty().append(data.markup).prop('disabled', false).removeProp('disabled');

                if (window.getUrlParameter('team_id'))
                {
                    $(oTheSelected.attr('data-selector-container')).val(window.getUrlParameter('team_id')).trigger('change');

                    //$(oTheContainer).prop('disabled', true);
                        
                }
            },
            function (data)
            {
                window.showError(data);
            });
        });

        $(document).on('change', '.prime-matches-section .prime-filter-item select.prime-teams', function()
        {
            let oTheSelected = $(this).find('option:selected');
            $('.prime-matches-section').attr('data-team-id', oTheSelected.val());
        });


        $(document).on('change', '.prime-matches-section .prime-filter-item .format:not(.include-all)', function() {
            $('.prime-matches-section').attr('data-format', $(this).val());
        });

        $(document).on('change', '.prime-matches-section .prime-filter-item .format.include-all.include-all-tournaments', function() {
            $('.prime-matches-section').attr('data-include-all-tournaments', $(this).prop('checked') ? true : 0);
            if ($(this).prop('checked'))
            {
                $('.form-control.prime-tournaments').prop('disabled', true);
            }
            else
            {
                $('.form-control.prime-tournaments').prop('disabled', false).removeProp('disabled');
            }
        });

        $(document).on('change', '.prime-matches-section .prime-filter-item .format.include-all.include-all-teams', function() {
            $('.prime-matches-section').attr('data-include-all-teams', $(this).prop('checked') ? true : 0);
            if ($(this).prop('checked'))
            {
                $('.form-control.prime-teams').prop('disabled', true);
                $('.form-control.prime-tournaments').prop('disabled', true);
                $('.prime-matches-section .prime-filter-item .format.include-all.include-all-tournaments').prop('disabled', true);
                $('.prime-matches-section .prime-filter-item .format.include-all.include-all-tournaments').next().addClass('-is-disabled');
            }
            else
            {
                $('.form-control.prime-teams').prop('disabled', false).removeProp('disabled');
                $('.prime-matches-section .prime-filter-item .format.include-all.include-all-tournaments').prop('disabled', false).removeProp('disabled');
                $('.prime-matches-section .prime-filter-item .format.include-all.include-all-tournaments').next().removeClass('-is-disabled');



                if ( !$('.prime-matches-section .prime-filter-item .format.include-all.include-all-tournaments').prop('checked') )
                {
                    $('.form-control.prime-tournaments').prop('disabled', false).removeProp('disabled');
                }
            }
        });

        $('.prime-matches-section .prime-matches-filter').click( function ()
        {
            let me = $(this);

            // ('fu');

            let oTheContainer = $('.prime-matches-container');

            let sTheQueryString = 'matches/?usenif';

            if ( $('#datepicker_to').val() && $('#datepicker_from').val() /*|| true*/)
            {

                if (!window.oTheParams['date_from'])
                {
                    let dateStr = $('#datepicker_from').val();
                    let from = dateStr.split('.');
                    let f = new Date(from[2], from[1] - 1, from[0]);
                    $('#datepicker_to').datepicker('option', 'minDate', f);
                    window.oTheParams['date_from'] =  Math.floor(f.getTime() / 1000);
                }

                if (!window.oTheParams['date_to'] || true)
                {
                    let dateStr = $('#datepicker_to').val();
                    let to = dateStr.split('.');
                    let t = new Date(to[2], to[1] - 1, to[0]);
                    $('#datepicker_from').datepicker('option', 'maxDate', t);
                    window.oTheParams['date_to'] =  Math.floor(t.getTime() / 1000);

                    console.log ('setting dates')
                    
                    console.log (window.oTheParams['date_from'] );
                    console.log (window.oTheParams['date_to'] );
                    console.log ('-----');

                    window.oTheParams['date_to'] += 86400;
                    

                    //alert (Math.floor(t.getTime() / 1000));
                    //alert (Math.floor(t.getTime() / 1000) + 86400);
                }
                

                

                me.prop('disabled', 'disabled');

                $(oTheContainer).empty().addClass('-is-loading').append(window.sTheLoader);

                sTheQueryString = sTheQueryString + '&size=1000&from=' + window.oTheParams['date_from'] + '&to=' + window.oTheParams['date_to'];

                //console.log ('-----------------------------------------------');
                //console.log (sTheQueryString);
                //console.log ('-----------------------------------------------');
                
                let sTheQueryType = 'matches-all';
                let iTheQueryID = 0;

                

                var sTheURL = window.location.protocol + '//' + window.location.hostname + '/' + $('.prime-matches-section').attr('data-page-slug') + '/?generate=true&from=' + window.oTheParams['date_from'] + '&to=' + (window.oTheParams['date_to'] - 86400);

                if ($('.prime-matches-section').attr('data-team-id') && !$('input#include-teams').is(':checked'))
                {
                    sTheQueryString = sTheQueryString + '&team_id=' + $('.prime-matches-section').attr('data-team-id');
                    sTheQueryType = 'matches-team';
                    //iTheQueryID = $('.prime-matches-section').attr('data-team-id');

                    sTheURL = sTheURL + '&team_id=' + $('.prime-matches-section').attr('data-team-id');;
                }

                console.log ('-----------------------------------------------');
                console.log (sTheURL);
                console.log ('-----------------------------------------------');

                if ($('.prime-matches-section').attr('data-tournament-id') && !$('input#include-tournaments').is(':checked') && !$('input#include-teams').is(':checked'))
                {
                    sTheQueryString = sTheQueryString + '&tournament_id=' + $('.prime-matches-section').attr('data-tournament-id');

                    if (!$('.prime-matches-section').attr('data-team-id'))
                    {
                        sTheQueryType = 'matches-tournament';
                        //iTheQueryID = $('.prime-matches-section').attr('data-tournament-id');
                    }

                    sTheURL = sTheURL +  '&tournament_id=' + $('.prime-matches-section').attr('data-tournament-id');
                }

                if ($('input#include-teams').is(':checked'))
                {
                    sTheQueryString = sTheQueryString + '&team_ids=' + $('.prime-matches-section').attr('data-extra-teams');
                    sTheQueryType = 'matches-team';
                    ///console.log ('-----------------------------------------------');
                    ///console.log (sTheURL);
                    ///console.log (sTheQueryString);
                    ///console.log ('-----------------------------------------------');
                }
            
                sTheQueryType = sTheQueryType + '#' + $('.prime-filter-group').find('.format:checked').val();

                var dt = new Date();

                sTheURL = sTheURL + "&format=" + $('.prime-filter-group').find('.format:checked').val() + '&timestamp=' + dt;

                $('button.matches-image-downloader').attr('data-href', sTheURL);

                iTheQueryID = $('.prime-matches-section').attr('data-team-id');
                
                window.Ajax.prime_v2 (
                {
                    template: 'listing/matches/image.php',
                    id:  iTheQueryID,
                    queryString: sTheQueryString,
                    queryType: sTheQueryType,
                    container: '.prime-matches-container',
                    siteType: $('.prime-matches-section').attr('data-site-type'),
                },
                function (data)
                {
                    $(oTheContainer).html(data.markup).removeClass('-is-loading');
                    me.prop('disabled', false).removeProp('disabled');
                    postProcessPrimeData($(data.param.container));
                },
                function (data)
                {
                    window.showError(data);
                });
            
            }
            else
            {
                alert ('Du må velge en fra dato.' + window.oTheParams['date_to'] );

            }
        });


     
        $(document).on('click', 'button.matches-image-downloader', function()
        {
            var $this = $(this);

            setTimeout(function() {
                $this.prop('disabled', 'disabled');

                $('.message').html('Bilde genereres i bakgrunnen. <br/>Vennligst vent, tjenesten kan bruke noe tid på prosessen. <br/>Bildet vil enten lastes direkte ned til din maskin, eller åpnes i et nytt vindu hvor du selv kan arkivere det til din maskin.');

            }, 0);


            setTimeout(function() {
                //console.log('click');
                const urlbox = Urlbox('ExCYItcVjoH4b2FI', 'bb6a0da115d243e48c308b0793ec656b');

                //console.log('click');
                var selector = '#urlBoxImageContainer';

                var url = $this.attr('data-href') + '&p=t';
                //console.log('click');

                var dt = new Date();
                //console.log('click');

                var timestamp = dt.getTime(); // Milliseconds
                //console.log('click');

            
                url = url + '&dt=' + timestamp;
                /*es-lint-disable*/
                console.log('click');

                /*es-lint-disable*/
                console.log(url);

                const options = {
                    url: url,
                    selector: selector,
                    thumb_width: 1800,
                    width: 1800,
                    format: "jpg",
                    quality: 100,
                };

                /*es-lint-disable*/
                //console.log(options);

                const imgUrl = urlbox.buildUrl(options);

                /*es-lint-disable*/
                //console.log(imgUrl);
                saveAs(imgUrl, $(selector).attr('data-id') + '_download.jpg');

                $('.message').html('<strong>Gratulerer, bildet er generert og ligger i nedlastingsmappen på maskinen din.</strong>');
                $this.prop('disabled', false).removeProp('disabled');

            }, 5);

        });


       

        $(document).on('click', 'button.generate-image', function()
        {
            var $this = $(this);

            setTimeout(function() {
                $this.prop('disabled', 'disabled');

                $('.message').html('Bilde genereres i bakgrunnen. <br/>Vennligst vent, tjenesten kan bruke noe tid på prosessen. <br/>Bildet vil enten lastes direkte ned til din maskin, eller åpnes i et nytt vindu hvor du selv kan arkivere det til din maskin.');

            }, 0);


            setTimeout(function() {
                const urlbox = Urlbox('ExCYItcVjoH4b2FI', 'bb6a0da115d243e48c308b0793ec656b');

                var dt = new Date();

                var url = $this.attr('data-href') + '&timestamp=' + dt;

                var selector, width, height;

                if ($this.hasClass('-is-square'))
                {
                    selector = '.svg-square-container';
                    width = 1024;
                    height = 1024;
                }
                else if ($this.hasClass('-is-wide'))
                {
                    selector = '.svg-wide-container';
                    width = 1820;
                    height = 1024;
                }
                else if ($this.hasClass('-is-tall'))
                {
                    selector = '.svg-tall-container';
                    width = 1024;
                    height = 1820;
                }
                else if ($this.hasClass('-is-instagram'))
                {
                    selector = '.svg-instagram-container';
                    width = 1024;
                    height = 1280;
                }
                else if ($this.hasClass('-is-event'))
                {
                    selector = '.svg-event-container';
                    width = 1957;
                    height = 1024;
                }

                const options = {
                    url: url,
                    selector: selector,
                    thumb_width: width,
                    width: width,
                    height:height,
                    format: "jpg",
                    quality: 100,
                };



                const imgUrl = urlbox.buildUrl(options);
                saveAs(imgUrl, $(selector).attr('id') + '_download.jpg');

                $('.message').html('<strong>Gratulerer, bildet er generert og ligger i nedlastingsmappen på maskinen din.</strong>');
                $this.prop('disabled', false).removeProp('disabled');

            }, 5);

        });

        //window.processcard = true;

        /*-----------------------------------------------------------------------------------------------------*/
        // STATS
        // utilities
        /*-----------------------------------------------------------------------------------------------------*/

        if ( window.getUrlParameter('prime_type') == 'tournament' )
        {
            //
        }
        else if (window.getUrlParameter('prime_type') == 'team')
        {
            //
        }
        else
        {
            if ($('.prime-stats-section .prime-seasons.-is-ready option').length > 1)
            {
                $('.prime-stats-section .prime-seasons').val( 2526 ).change().removeClass('-is-ready');
            }
        }

        

        function postProcessPrimeData (oTheContainer)
        {

            if ( $('body.team.home').length > 0 && oTheContainer.hasClass('prime-hero'))
            {
                let top = 0;

                if ( window.iTheWidth < window.iTheHeight)
                {
                    $('.hero-content').css({'background-size' :  'auto calc(100vh - ' + top + 'px)', 'background-position' : 'center 0px'});
                    $('.hero-content').css({'height' :  'calc(100vh - ' + top + 'px)'});
                    
                    top = $('.single-match-info').outerHeight() ;
                }
                else
                {
                    $('.hero-content').css({'background-size' :  'cover', 'background-position' : 'center center'});
                    top = $('.single-match-info').outerHeight();
                }

                 let mTop = parseInt($('.single-match-info').css('padding-top'), 10);

                $('.hero-content').addClass('-is-loaded');
                
                if ($(window).scrollTop() == 0)
                {
                    gsap.to(window, { scrollTo: (top + mTop + mTop), delay: 0.5 });
                }
            }
            

            if ( $('body.nth.home').length > 0 && oTheContainer.closest('section').hasClass('prime-match-slider-outer') && nth_hero_scrolled == false)
            {
                nth_hero_scrolled = true;

                //window.scrollTo({top: 0});

                //window.isScrolled = false;
                let mTop = parseInt($('.prime-match-slider-outer').css('margin-top'), 10);

                let top = $('.prime-match-slider-outer').outerHeight() + (mTop * 2);

                //console.log (top);
                
                if ($(window).scrollTop() == 0)
                {
                    gsap.to(window, { scrollTo: top, delay: 0.5 });
                }
        
            }

            if ( $(oTheContainer).find('.player-ranks-wrapper').length > 0)
            {
                const limit = 3;

                $('.prime-player-ranks').each(function (i)
                {
                    let iTheInitialTeamID;
                    let iTheSameTeamCount = 0;
                    let iTheRowCount = 0;
                    let sTheLastSelectedType = "";

                    if ($('body').hasClass('team'))
                    {
                        $(this).find('.player-rank').each( function()
                        {
                            if (iTheRowCount == 0)
                            {
                                iTheInitialTeamID = $(this).attr('data-team-id');
                            }
                            else if (iTheRowCount > 0 && iTheRowCount <= limit)
                            {
                                if ($(this).hasClass('-is-same') && iTheInitialTeamID == $(this).attr('data-team-id'))
                                {
                                    iTheSameTeamCount++;
                                    sTheLastSelectedType = $(this).attr('data-type');
                                }
                                else
                                {
                                    iTheSameTeamCount = 0;
                                }
                            }
                            else if (iTheRowCount > limit)
                            {
                                $(this).addClass('-is-hideable');
                                $(this).hide();
                            }
                            iTheRowCount++;
                        });

                        if (iTheSameTeamCount >= limit )
                        {
                            for (let i = limit - 1; i < iTheSameTeamCount; i++)
                            {
                                $(this).find('.player-rank').eq(i+1).addClass('-is-hideable').hide();
                            }
                            $(this).find('.player-rank').each( function()
                            {
                                if (sTheLastSelectedType == "home" && $(this).hasClass('away'))
                                {
                                    $(this).removeClass('-is-hideable').show();
                                    return false;
                                }
                                else if (sTheLastSelectedType == "away" && $(this).hasClass('home'))
                                {
                                    $(this).removeClass('-is-hideable').show();
                                    return false;
                                }
                            });
                        }
                    }

                    if ($('body').hasClass('nth'))
                    {
                        $(this).find('.player-rank').each( function()
                        {
                            
                            if (iTheRowCount > limit)
                            {
                                $(this).addClass('-is-hideable');
                                $(this).hide();
                            }
                            iTheRowCount++;
                        });
                    }

                    $(document).on('click', '.show-all', function() {
                        $(this).closest('tbody').find('.-is-hideable').show();
                        $(this).removeClass('show-all').addClass('show-less').find('span').text('Vis færre');
                    });

                    $(document).on('click', '.show-less', function() {
                        $(this).closest('tbody').find('.-is-hideable').hide();
                        $(this).removeClass('show-less').addClass('show-all').find('span').text('Vis flere');
                        $(window).scrollTop($(this).closest('table').offset().top - 100);
                    });

                    if (iTheRowCount <= 3)
                    {
                        $(this).find('.show-all').closest('tr').hide();
                    }
                });
            }

            if (oTheContainer.find('.countdown-container').length > 0)
            {
                oTheContainer.find('.countdown-container').each( function() {
                    $(this).countdown($(this).attr('data-time'), function(event) {
                        $(this).html(event.strftime(''
                            + '<div class="column"><div class="countdown"><div class="box"><span class="value">%D</span><span class="label">dager</span></div></div></div>'
                            + '<div class="column"><div class="countdown"><div class="box"><span class="value">%H</span><span class="label">timer</span></div></div></div>'
                            + '<div class="column"><div class="countdown"><div class="box"><span class="value">%M</span><span class="label">min</span></div></div></div>'
                            + '<div class="column"><div class="countdown"><div class="box"><span class="value">%S</span><span class="label">sek</span></div></div></div>'
                        ));
                    });

                    /*$(this).html(''
                        + '<div class="column"><div class="countdown"><div class="box"><span class="value">01</span><span class="label">dager</span></div></div></div>'
                        + '<div class="column"><div class="countdown"><div class="box"><span class="value">21</span><span class="label">timer</span></div></div></div>'
                        + '<div class="column"><div class="countdown"><div class="box"><span class="value">23</span><span class="label">min</span></div></div></div>'
                        + '<div class="column"><div class="countdown"><div class="box"><span class="value">59</span><span class="label">sek</span></div></div></div>'
                    );*/

                    //$(this).find('.countdown').css({'width' : $(this).find('.countdown').outerHeight() + 'px'});

                });
            }

            if ($('body').hasClass('page-template-template-stats')
                || $('body').hasClass('page-template-template-player')
                || $('.single-match-stats-wrapper').length > 0 )
            {
                initializeTableSorter('body');
            }

            if ($ ('.content-screen.stats').length > 0)
            {
                //console.log('postProcessPrimeData');
                //console.log(oTheContainer);

                initializeTableSorter('.content-screen.stats');
            }





            if (oTheContainer.find('.prime-combine-selected').length == 1)
            {
                $('.prime-combine-selected').click();
            }

            // STATS NAVIGATION
            if ( $('.prime-stats-section').length > 0 && window.bTheInitial == true )
            {
                if (window.getUrlParameter('prime_type') == 'tournament')
                {
                    if ($('.prime-stats-section .prime-tournaments').find('option').length > 1 && $('.prime-stats-section').attr('data-tournament-id'))
                    {
                        window.bTheInitial = false;
                        $('.prime-stats-section .prime-tournaments').val( $('.prime-stats-section').attr('data-tournament-id') ).change().removeClass('-is-ready');
                        $('.prime-stats-filter').click();
                    }
                    else
                    {
                        //$('.prime-stats-section .prime-tournaments option[value=0]').attr('selected','selected');
                    }
                }

                if (window.getUrlParameter('prime_type') == 'team')
                {
                    if ($('.prime-stats-section .prime-tournaments.-is-ready').find('option').length > 1 && $('.prime-stats-section').attr('data-tournament-id'))
                    {
                        $('.prime-stats-section .prime-tournaments').val( $('.prime-stats-section').attr('data-tournament-id') ).change().removeClass('-is-ready');
                    }
                    else
                    {
                        //$('.prime-stats-section .prime-tournaments option[value=0]').attr('selected','selected');
                    }

                    if ($('.prime-stats-section .prime-teams option').length > 1 && $('.prime-stats-section').attr('data-team-id'))
                    {
                        window.bTheInitial = false;
                        $('.prime-stats-section .prime-teams').val( $('.prime-stats-section').attr('data-team-id') ).change().removeClass('v2');
                        $('.prime-stats-filter').click();
                    }
                    else
                    {
                        //$('.prime-stats-section .prime-teams option[value=0]').attr('selected','selected');
                    }
                }
            }

            setPlayerCard();

            $(oTheContainer).find('.prime-data.v2').each( function ()
            {
                //console.log ('repeat offender!');
                //////console.log ($(this).attr('class'));

                let oTheInner = $(this);
                oTheInner.addClass('-is-loading-resources').empty().append(window.sTheLoader);

                ////console.log(`Starting SUB AJAX for: ${oTheInner.attr('class')} at ${new Date().toISOString()}`);

                window.Ajax.prime_v2 (
                {
                    template: oTheInner.attr('data-content-template'),
                    id: oTheInner.attr('data-id'),
                    queryString: oTheInner.attr('data-content-query'),
                    queryType: oTheInner.attr('data-query-type'),
                    homeTeam: oTheInner.attr('data-home-team'),
                    awayTeam: oTheInner.attr('data-away-team'),
                    match: oTheInner.attr('data-match'),
                    container: oTheInner.attr('data-content-container'),
                },
                function (data)
                {
                    $(data.param.container).removeClass('-is-loading-resources').empty().append(data.markup);

                    ////console.log(`Processing SUB AJAX for: ${oTheInner.attr('class')} at ${new Date().toISOString()}`);

                    postProcessPrimeData($(data.param.container));

                    $(data.param.container).closest('.col').find('.prime-matches-single-info-title').removeClass('d-none');

                    // remove if empty: -if-empty-remove

                    if (data.count == 0 && $(data.param.container).hasClass('-if-empty-remove'))
                    {
                        $(data.param.container).remove();
                    }

                    


                },
                function (data)
                {
                    window.showError(data);
                });
            });
        }

        

        /*-----------------------------------------------------------------------------------------------------*/
        // statsfilter, data parameters
        /*-----------------------------------------------------------------------------------------------------*/

        var oTheParams = {};
        oTheParams['season'] = 0;
        oTheParams['tournament_id'] = 0;
        oTheParams['team_id'] = 0;
        oTheParams['date_from'] = 0;
        oTheParams['date_to'] = 0;
        window.oTheParams = oTheParams;

        if ($( '.datepicker' ).length > 0)
        {
            $('.prime-stats-section #datepicker_from').datepicker({
                minDate: new Date(2017, 1 - 1, 1),
                maxDate: '+1d',
                onSelect: function(dateStr)
                {
                    let from = dateStr.split('.');
                    let f = new Date(from[2], from[1] - 1, from[0]);
                    $('#datepicker_to').datepicker('option', 'minDate', f);
                    window.oTheParams['date_from'] =  Math.floor(f.getTime() / 1000);
                },
            });
            $('.prime-stats-section #datepicker_to').datepicker({
                minDate: new Date(2017, 1 - 1, 1),
                maxDate: '+1d',
                onSelect: function(dateStr)
                {
                    let from = dateStr.split('.');
                    let f = new Date(from[2], from[1] - 1, from[0]);
                    $('#datepicker_from').datepicker('option', 'maxDate', f);
                    window.oTheParams['date_to'] =  Math.floor(f.getTime() / 1000);
                },
            });


            $('.prime-matches-section #datepicker_from').datepicker({
                onSelect: function(dateStr)
                {
                    let from = dateStr.split('.');
                    let f = new Date(from[2], from[1] - 1, from[0]);
                    $('#datepicker_to').datepicker('option', 'minDate', f);
                    window.oTheParams['date_from'] =  Math.floor(f.getTime() / 1000);
                },
            });


            $('.prime-matches-section #datepicker_to').datepicker({
                onSelect: function(dateStr)
                {
                    let from = dateStr.split('.');
                    let f = new Date(from[2], from[1] - 1, from[0]);
                    $('#datepicker_from').datepicker('option', 'maxDate', f);
                    window.oTheParams['date_to'] =  Math.floor(f.getTime() / 1000);
                },
            });



        }


        /*-----------------------------------------------------------------------------------------------------*/
        // statstable, show hide additional cells
        /*-----------------------------------------------------------------------------------------------------*/


        $(document).on('click', '.stats-expander', function()
        {

            $(this).closest('.prime-stats-table-container').find('.secondary').toggleClass('d-none').toggleClass('-is-active');
            $(this).toggleClass('active');

        });

        /*-----------------------------------------------------------------------------------------------------*/
        // statstable, show hide tooltip
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('mouseenter', '.prime-stats-table th', function()
        {
            let diff = $(this).closest('.prime-stats-table-container').css('padding').replace('px', '') * 1;
            let dist = $(this).offset().left + ($(this).innerWidth() / 2);

            $(this).closest('.prime-stats-table-container').find('.tooltip').html($(this).attr('data-title'));
            $(this).closest('.prime-stats-table-container').find('.tooltip').addClass('-is-active').css({'left' : dist +  'px'});
        });

        $(document).on('mouseleave', '.prime-stats-table th', function()
        {
            $(this).closest('.prime-stats-table-container').find('.tooltip').html('');
            $(this).closest('.prime-stats-table-container').find('.tooltip').removeClass('-is-active');
            //$(this).find('span').removeClass('d-none');
        });



        /*-----------------------------------------------------------------------------------------------------*/
        // single match stats, show hide stats tables
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('click', '.match-stats-expander', function()
        {
            if ($(this).next('.match-stats').length > 0)
            {
                $(this).next('.match-stats').toggleClass('d-none');
                $(this).toggleClass('-do-reveal').toggleClass('-do-hide');
            }
            else if ($(this).next('.prime-roster-all').length > 0)
            {
                $(this).next('.prime-roster-all').toggleClass('d-none');
                $(this).toggleClass('-do-reveal').toggleClass('-do-hide');
            }
        });

        /*-----------------------------------------------------------------------------------------------------*/
        // single player stats, show hide stats tables
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('click', '.player-stats-expander', function()
        {
            if ($(this).next('.prime-stats-container').length > 0)
            {
                $(this).next('.prime-stats-container').toggleClass('d-none').toggleClass('d-flex');
                $(this).toggleClass('-do-reveal').toggleClass('-do-hide');
            }
        });


        /*-----------------------------------------------------------------------------------------------------*/
        // kaia content, image slideshow
        /*-----------------------------------------------------------------------------------------------------*/

        $('.image-container.-is-gallery').each(function (i)
        {
            var images = $(this).find('img');
            var indicators = $(this).find('.indicators');
            let currentIndex = 0;
            gsap.set(images, { opacity: 0 });
            gsap.set(images[0], { opacity: 1 });
            $(this).find('.indicators').find('.indicator').eq(0).addClass('active');

            function showImage($this, index)
            {
                let images = $this.closest('.image-container').find('img');
                if (index === currentIndex) return;
                gsap.to(images[currentIndex], { opacity: 0, duration: 0.5 });
                gsap.to(images[index], { opacity: 1, duration: 0.5 });
                $this.closest('.image-container').find('.indicator').removeClass('active');
                $this.addClass("active");
                currentIndex = index;
            }

            $('.indicator').on('click', function()
            {
               showImage($(this),$(this).attr('data-index'));
            });

        });

        /*-----------------------------------------------------------------------------------------------------*/
        // rnavbar fade up and down
        /*-----------------------------------------------------------------------------------------------------*/

        var c, currentScrollTop = 0, navbar;

        


        $(window).scroll(function()
        {
            window.iTheHeight = $(window).height() || window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            var st = $(this).scrollTop();
            window.lastScrollTop = st;
            onWindowScrollAction();

            navbar = $('body > header.site-header:not(.-has-club-light-bg)');

            let a = $(window).scrollTop();
            let b = navbar.height();
            currentScrollTop = a;

            if (window.disableHeaderAnim == false)
            {

                if ( ($('body.team.home').length > 0 || $('body.nth.home').length > 0)
                    &&
                    ( $('.single-match-info').length > 0 || $('.prime-matches-horizontal').length > 0 )
                    &&
                    $('.hero-content').length  > 0 )
                {
                    var top;

                    if ($('body.nth.home').length > 0)
                    {
                        let mTop = parseInt($('.prime-match-slider-outer').css('margin-top'), 10);
                        ////console.log (mTop);
                        top = ($('.prime-match-slider-outer').outerHeight() + mTop + mTop) ;
                    }

                    if ($('body.team.home').length > 0)
                    {
                        top = $('.single-match-info').outerHeight() * 1.5;
                    }

                    ////console.log (top);

                    if (st > top)
                    {
                        if (c < currentScrollTop && a > b + b)
                        {
                            navbar.addClass('hide-nav').removeClass('show-nav');
                        }
                        else if (c > currentScrollTop && !(a <= b))
                        {
                            navbar.removeClass('hide-nav').addClass('show-nav');
                        }

                    }
                }
                else
                {
                    if (c < currentScrollTop && a > b + b)
                    {
                        navbar.addClass('hide-nav').removeClass('show-nav');
                    }
                    else if (c > currentScrollTop && !(a <= b))
                    {
                        navbar.removeClass('hide-nav').addClass('show-nav');
                    }

                }
            }
            else
            {
                if (currentScrollTop > 100)
                {
                    navbar.addClass('hide-nav').removeClass('show-nav');
                }
                else
                {
                    navbar.removeClass('hide-nav').addClass('show-nav');
                }
            }

            if ( $('.prime-stats-table').length > 0 )
            {
                $('.prime-stats-table').each(function () {

                    if ( window.isTopAboveViewportTop($(this), $(window)) && !window.isBottomAboveViewportTop ($(this), $(window)) && !$(this).closest('.prime-stats-table-container').hasClass('-lock-to-viewport') )
                    {
                        $(this).find('thead tr').find('th').each( function (index)
                        {
                            $(this).css({'width' : $(this).outerWidth() + 'px'});
                        });

                        $(this).closest('.prime-stats-table-container').addClass('-lock-to-viewport');
                        $(this).find('thead > tr').clone().addClass('-is-spacer-row').insertAfter( $(this).find('thead > tr') );


                        var iTheTW = 0
                        $(this).find('.tablesorter-headerRow:not(.-is-spacer-row)').find('th').each ( function (i)
                        {
                            let iTheW = $(this).find('.tablesorter-headerRow.-is-spacer-row').find('th:nth-child(' + (i + 1) + ')').outerWidth();
                            $(this).css({'width' : iTheW + 'px'});
                            iTheTW = iTheTW + iTheW;
                        });

                        $(this).find('.tablesorter-headerRow:not(.-is-spacer-row)').css({'width' : iTheTW + 'px'});

                        if ($(this).outerWidth() > $(this).closest('.table-scroll-container').outerWidth())
                        {
                            ////console.log ('wide table');
                            $(this).find('.table-scroll-container').scrollLeft( $(this).find('.table-scroll-container').scrollLeft() - 1);
                        }

                        window.disableHeaderAnim = true;

                    }
                    else if ( ( window.isBottomAboveViewportTop ($(this), $(window)) && $(this).closest('.prime-stats-table-container').hasClass('-lock-to-viewport'))  || ( !window.isTopAboveViewportTop($(this), $(window)) && $(this).closest('.prime-stats-table-container').hasClass('-lock-to-viewport') ) )
                    {
                        $(this).closest('.prime-stats-table-container').removeClass('-lock-to-viewport');
                        $(this).find('.-is-spacer-row').remove();
                        $(this).find('.tablesorter-headerRow').css('transform','none');
                        $(this).find('.tablesorter-headerRow').find('.player-main').css('transform','none');

                        window.disableHeaderAnim = false;
                    }

                });
            }


            c = currentScrollTop;


        });


        /*-----------------------------------------------------------------------------------------------------*/
        // rnavbar expand subs
        /*-----------------------------------------------------------------------------------------------------*/

        $('.menu-item-has-children .prime-icon').click( function (e) {

            e.stopPropagation();
            $(this).closest('.menu-item-has-children').toggleClass('-is-expanded');
    
        });

        $('.menu-item-has-children.-is-trigger-only').click( function (e) {

            e.stopPropagation();

            $(this).toggleClass('-is-expanded');

    
        });



        /*-----------------------------------------------------------------------------------------------------*/
        // club tabs
        /*-----------------------------------------------------------------------------------------------------*/

        var iTheCurrentSiteID = 0;
        window.iTheCurrentSiteID = iTheCurrentSiteID;

        $('.post-selector-button').click( function (e)
        {
            e.preventDefault();
            let iTheID = $(this).attr('data-blog-id')*1;
            //$(this).closest('.filter-container').find('.all-posts').removeClass('-is-visible').addClass('-is-hidden');
            //$(this).closest('.filter-container').find('.all-posts' + sTheID).addClass('-is-visible').removeClass('-is-hidden');

            let all = 0;
            $(this).closest('.filter-container').find('.all-posts').find('.single-archive-article').each( function ()
            {
                if (all < 19 && ($(this).attr('data-site-id')*1 == iTheID || iTheID == 0))
                {
                    $(this).addClass('-is-visible').removeClass('-is-hidden');

                    window.iTheCurrentSiteID = iTheID;

                    all ++;
                }
                else
                {
                    $(this).addClass('-is-hidden').removeClass('-is-visible');
                }
            });
        });


        function onWindowScrollAction()
        {
            if ($('.single-archive-article').length > 0)
            {
                $('.single-archive-article').each (function () {

                    if ( window.isInViewport ($(this), $(window)))
                    {
                        if (window.iTheCurrentSiteID == 0 || window.iTheCurrentSiteID == $(this).attr('data-site-id') * 1)
                        {
                            $(this).addClass('-is-visible').removeClass('-is-hidden');
                        }
                    }
                });
            }
        }

        window.doResize();


        /*-----------------------------------------------------------------------------------------------------*/

        /* TABLE SORTER */

        /*-----------------------------------------------------------------------------------------------------*/

        function setupTableSorter($table, initialSortColumn, activeColumn) {
            return $table.tablesorter({
                sortList: [[initialSortColumn, 1]],
                sortInitialOrder: 'desc',
                widgets: ['filter'],
                widgetOptions: {
                    filter_external: '.search',
                    filter_defaultFilter: { 1: '~{query}' },
                    filter_columnFilters: false,
                    filter_placeholder: { search: 'Søk...' },
                    filter_saveFilters: true,
                    filter_reset: '.reset',
                },
            }).on('sortStart', () => {
                window.disableHeaderAnim = true;
            }).on('sortEnd', function (e) {
                const $target = $(e.target);
                const $container = $target.closest('.prime-stats-table-container');

                if ($container.hasClass('-lock-to-viewport')) {
                    let totalWidth = 0;
                    $target.find('.tablesorter-headerRow:not(.-is-spacer-row) th').each(function (i) {
                        const width = $('.tablesorter-headerRow.-is-spacer-row th').eq(i).outerWidth();
                        $(this).css('width', width + 'px');
                        totalWidth += width;
                    });
                    $target.find('.tablesorter-headerRow:not(.-is-spacer-row)').css('width', totalWidth + 'px');
                }

                let i = 1;
                $target.find('tbody tr').each(function () {
                    $(this).find('th > span.number').text(i + '.');
                    i++;
                });
            });
        }

        function setupPager($table, $pagerContainer, pageSize = 20) {
            const rowCount = $table.find('tbody tr').length;

            if (rowCount <= pageSize) { // Don't enable pager if not needed
                
                $pagerContainer.remove();
                return;
            }

            const pagerOptions = {
                container: $pagerContainer,
                size: pageSize,
                output: '{startRow} til {endRow} / {filteredRows}',
                savePages: false,
                storageKey: 'tablesorter-pager',
                pageReset: 0,
                fixedHeight: false,
                removeRows: false,
                countChildRows: false,
                cssNext: '.next',
                cssPrev: '.prev',
                cssFirst: '.first',
                cssLast: '.last',
                cssGoto: '.gotoPage',
                cssPageDisplay: '.pagedisplay',
                cssPageSize: '.pagesize',
                cssDisabled: 'disabled',
                cssErrorRow: 'tablesorter-errorRow',
            };

            $table.bind('pagerChange pagerComplete pagerInitialized pageMoved', function (e, c) {
                const msg = `"</span> event triggered, ${e.type === 'pagerChange' ? 'going to' : 'now on'} page <span class="typ">${c.page + 1}/${c.totalPages}</span>`;
                $('#display').append(`<li><span class="str">"${e.type}${msg}</li>`).find('li:first').remove();
            });

            $table.tablesorterPager(pagerOptions);

            $('.clear-pager-data').click(() => {
                $.tablesorter.storage($table, 'tablesorter-pager', '');
            });

            $('.goto').click(() => {
                $table.trigger('pageAndSize', [1, pageSize]);
            });
        }

        function initializeTableBlock($container, selector, pagerSelector, isTeamStats, initialCol, activeCol) {
            const $table = $container.find(`table.${selector}`);
            if (!$table.length) return;

            const $pager = $container.find(pagerSelector);
            const colInit = isTeamStats ? initialCol - 1 : initialCol;
            const colActive = isTeamStats ? activeCol - 1 : activeCol;

            setupTableSorter($table, colInit, colActive);
            if ($pager.length) {
                $pager.each(function () {
                    setupPager($table, $(this));
                });
            }

            $table.find(`tbody td:nth-child(${colActive + 1})`).addClass('-is-sorted');
        }

        function initializeTableSorter(oTheContainer) {
            const $container = $(oTheContainer);
            const isTeamStats = $container.find('.prime-match-pitch-stats-table').hasClass('stats_team');

            initializeTableBlock($container, 'prime-match-pitch-stats-table', '.pitch.pager', isTeamStats, 3, 4);
            initializeTableBlock($container, 'prime-match-goalie-stats-table', '.goalie.pager', isTeamStats, 2, 3);
        }


        /*-----------------------------------------------------------------------------------------------------*/

        /* PLAYER CARDS */

        /*-----------------------------------------------------------------------------------------------------*/
        window.playerCardIsSet = false;

        function scaleCardToFit() {

            //console.log('scaleCardToFit');
            //console.log($('body').find('#playercard-modal').length);

            if ( $('body').find('#playercard-modal').length != 0)
            {
                const $modal = $('.modal-body');
                const $card = $('.card-container');
            
                const modalWidth = $modal.width();
                const modalHeight = $modal.height();
            
                const cardWidth = 1080;
                const cardHeight = 1920;
            
                const scale = Math.min(modalWidth / cardWidth, modalHeight / cardHeight);
            
                // Apply scale and center
                $card.css({
                    transform: `scale(${scale}) translate(-50%, -50%)`,
                    top: '50%',
                    left: '50%',
                    position: 'absolute',
                    transformOrigin: 'top left',    
                });

                $('.modal-body').css({
                    aspectRatio: '9/16',
                    overflow: 'auto',
                    height: '80vh',
                });

            }
        }
        
        // Call it once on load
        scaleCardToFit();
        
        // And on resize
        $(window).on('resize', scaleCardToFit);

        function setPlayerCard()
        {
            if ( $('svg#playercard').length > 0 && window.playerCardIsSet == false)
            {
                $('svg#playercard').find('.placeholder').each ( function ()
                {
                    let mybounds = $(this)[0].getBoundingClientRect();
                    let modalTop = 0;
                    let modalLeft = 0;

                    if ( $(this).closest('.modal-content').length > 0)
                    {
                        modalTop = $(this).closest('.modal-content').offset().top;
                        modalLeft = $(this).closest('.modal-content').offset().left;
                    }


                    $('.' + $(this).attr('id')).css({'top' : (mybounds.top - modalTop) + 'px', 'left' : (mybounds.left - modalLeft) + 'px', 'height' : mybounds.height + 'px', 'width' : mybounds.width + 'px' });
                });

                window.playerCardIsSet = true;

                scaleCardToFit();
            }
        }

        setPlayerCard();

        /*-----------------------------------------------------------------------------------------------------*/
        // player download card image
        /*-----------------------------------------------------------------------------------------------------*/

        $(document).on('click', '.player-card-downloader', function()
        {
            //let sTheID = $(this).attr('data-id');



            // Plugin your API key and secret
            const urlbox = Urlbox('ExCYItcVjoH4b2FI', 'bb6a0da115d243e48c308b0793ec656b');

            var selector = '#' + $(this).closest('.prime-single-player-card').find('.card-container').attr('id');

            var url = window.location.protocol + '//' + window.location.hostname + '/spillerkort/?player_id=' + $(this).attr('data-player') + '&type=' + $(this).attr('data-type');

            if ($(this).attr('data-tournament'))
            {
                url = url + '&context_id=' + $(this).attr('data-tournament');
            }

            var dt = new Date();
            var timestamp = dt.getTime(); // Milliseconds

            url = url + '&dt=' + timestamp;

            //console.log(url);

            //return false;

            // Set your options
            const options = {
                url: url,
                //selector: selector,
                width: 1080,
                height: 1920,
                thumb_width: 1080,
                format: 'jpg',
                quality: 100,
            };

            const imgUrl = urlbox.buildUrl(options);
            saveAs(imgUrl, selector + '.jpg');


        });

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js